import { Lethargy } from "lethargy";

declare const jQuery: any;
const $ = jQuery;

export interface ScrollBeyondSettings
{
    type: "wheel"|"scrollY"|"scrollX";
    onScrollPastMin?: (event?) => void;
    onScrollPastMax?: (event?) => void;
    waitAfter?: number; // milliseconds
    stopPropagation?: boolean; // default true
    preventDefault?: boolean; // default true
    
}

// for horizontal scrolling only
export function listenForScrollBeyond(settings: ScrollBeyondSettings, $el): void
{
    $el = $($el);
    const el: HTMLElement = $el[0];
    if (!el)
    {
        console.warn(`No element passed to listenForScrollBeyond`);
        return;
    }

    const onScrollPastMin = settings.onScrollPastMin;
    const onScrollPastMax = settings.onScrollPastMax;
    const stopPropagation: boolean = (settings.stopPropagation === undefined) ? true : settings.stopPropagation;
    const preventDefault: boolean = (settings.preventDefault === undefined) ? true : settings.preventDefault;
    const waitAfter: number = (settings.waitAfter === undefined) ? 200 : settings.waitAfter;
    const type: string = settings.type;
    const eventType: string = (type === "wheel") ? "wheel" : "scroll";
    const doLethargyCheck: boolean = (type === "wheel" || type === "scrollY");
    const scrollingX: boolean = (type === "scrollX");
    const lethargy = new Lethargy();

    let scrolledRecently = false;
    let scrolledRecentlyTimer: any;
    let prevScrollValue: number;

    const setScrolledRecentlyFalseTimed = () => {
        clearTimeout(scrolledRecentlyTimer);
        scrolledRecentlyTimer = setTimeout(() => {
            scrolledRecently = false;
        }, waitAfter);
    };

    $el.on(eventType, function (event) {
        if (stopPropagation)
        {
            event.stopPropagation();
        }
        if (preventDefault)
        {
            event.preventDefault();
        }

        let scrollingTowardsMin: boolean;
        let scrollingTowardsMax: boolean;

        if (doLethargyCheck)
        {
            const lethargyValue = lethargy.check(event);
            if (!lethargyValue)
            {
                return;
            }
            scrollingTowardsMax = (lethargyValue === -1);
            scrollingTowardsMin = !scrollingTowardsMax;
        }
        else
        {
            const scrollValue: number = scrollingX ? el.scrollLeft : el.scrollTop;
            scrollingTowardsMin = scrollValue < prevScrollValue;
            scrollingTowardsMax = scrollValue > prevScrollValue;

            console.log("scrollValue",scrollValue,"towardsMin",scrollingTowardsMin,"towardsMax",scrollingTowardsMax);//fixme
            prevScrollValue = scrollValue;

            if (el.scrollLeft === 0)
            {
                el.scrollLeft = 1;
            }
            else {
                // fixme deal with scroilled to max
            }
        }
        
        if (!scrolledRecently)
        {
            if (scrollingTowardsMax && elementIsScrolledToMax(el))
            {
                if (onScrollPastMax)
                {
                    onScrollPastMax(event);
                }
            }
            else if (scrollingTowardsMin && elementIsScrolledToMin(el))
            {
                if (onScrollPastMin)
                {
                    onScrollPastMin(event);
                }
            }
        }
        scrolledRecently = true;
        setScrolledRecentlyFalseTimed();
    });
}

function elementIsScrolledToMin(el: HTMLElement): boolean
{
    return el.scrollLeft <= 0;
}

function elementIsScrolledToMax(el: HTMLElement): boolean
{
    const maxScroll: number = el.scrollWidth - el.clientWidth;
    return el.scrollLeft >= maxScroll;
}
